<template>
  <!---s-dg-notice-->
  <van-popup class="p1_bgnotice p1_dialognotice" :overlay="true" @click="clickNotice" overlay-class="p1_noticeOverlay"
             @click-overlay="clickNotice" :close-on-click-overlay="false" v-bind:value="popnotice">
    <!---s-tx-msg-->
    <div class="p1_textmsg">{{ errMsg }}</div>
  </van-popup>
</template>

<style scoped>
@import "../../assets/p1/css/s1.css";
</style>
<script>

export default {
  name: 'ShowErr',
  data() {
    return {
      errMsg: '',
      popnotice: false,
      timeOut: null,
    };
  },

  methods: {
    showErr(msg, hide = true) {
      this.errMsg = msg
      this.popnotice = true

      if (hide) {
        clearTimeout(this.timeOut)
        let that = this
        this.timeOut = setTimeout(function () {
          that.popnotice = false
        }, 1500)
      }
    },
    clickNotice() {
      this.popnotice = false
    },
  },
  mounted() {

  },
};
</script>

<style>
.p1_noticeOverlay {
  background-color: transparent;
}
</style>
<style scoped>

.p1_noticeOverlay {
  background-color: transparent;
}

.p1_bgnotice {
  width: auto;
}
.p1_textmsg {
  align-content: center;
  text-align: center;
  width: max-content;
  margin-right: 0.480rem;
}
</style>
<style scoped>
.van-popup {
  background-color: transparent;
}
</style>